// extracted by mini-css-extract-plugin
module.exports = {"childrenInfo":"vendor-information_childrenInfo__3MKFb","hidden":"vendor-information_hidden__2WiYA"};